export enum LocalStorageKeys {
  CONTACT_FORM_DATA = "contact_form_data",
  CONTACT_FORM_STAGE = "contact_form_stage",
  CONTACT_SALES_FORM = "contact_sales_form_v2",
  CONTENT_GATE_UNLOCKED = "content-gate-unlocked",
  CONVAI_MARKETING_PAGE_TERMS = "convai_marketing_page_terms",
  CURRENCY = "preferred_currency",
  CURRENCY_LOCALE = "preferred_currency_locale",
  DEVELOPER_OMNIBOX_LANGUAGE = "developer-omnibox-language",
  GCLID = "gclid",
  LANGUAGE_PREFERENCE = "marketing-website-language-preference",
  PH_CONSENT_DECISION = "ph_consentDecision",
  REFERRAL_LINK = "viaReferralLink",
  SFX_DOWNLOAD_COUNT = "xi:marketing-sfx-download-count",
  SOUNDBOARD_MIDI_MAPPING = "soundboardMidiMapping",
  SOUNDBOARD_STATE = "soundboardState",
  TTS_SIGNUP_POPOVER_DISMISSED = "tts-signup-popover-dismissed",
  VOICE_CHANGER_NUDGE_SHOWN_AT = "mw-voice-changer-nudge-shown-at",
  VOICE_CLONING_NUDGE_SHOWN_AT = "mw-voice-cloning-nudge-shown-at",
  UTM_CAMPAIGN = "utm_campaign",
  UTM_CONTENT = "utm_content",
  UTM_MEDIUM = "utm_medium",
  UTM_SOURCE = "utm_source",
  UTM_TERM = "utm_term",
  V3_AGENTS_CONVERSATION_HISTORY = "v3_agents_conversation_history",
}

/**
 * Safe localStorage wrapper that silently handles environments where
 * localStorage is unavailable (null), access is denied (SecurityError),
 * or quota is exceeded.
 *
 * Drop-in replacement: use `safeLocalStorage.getItem(key)` instead of
 * `localStorage.getItem(key)`.
 */
export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // localStorage unavailable, access denied, or quota exceeded
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // localStorage unavailable or access denied
    }
  },
};

export const setLocalStorage = (key: LocalStorageKeys, value: string) => {
  safeLocalStorage.setItem(key, value);
};

export const getLocalStorage = (key: LocalStorageKeys) => {
  return safeLocalStorage.getItem(key);
};
